export class Daemons {
  constructor(http) {
    this.http = http;
  }

  fetchDaemons() {
    return this.http.get('daemons/').then(response => response.data);
  }

  calculateStat() {
    return this.http.get('calculate/').then(response => response.data);
  }

  syncDaemons() {
    return this.http.get('daemons/sync/').then(response => response.data);
  }

  syncAccounts(id) {
    return this.http.get(`daemons/${id}/accounts/`).then(response => response.data);
  }

  syncStats(id) {
    return this.http.get(`daemons/${id}/stat/`).then(response => response.data);
  }

  sendHotList(id) {
    return this.http.get(`daemons/${id}/hotlist/`).then(response => response.data);
  }

  syncAccountsAll() {
    return this.http.get(`daemons/accounts/sync/`).then(response => response.data);
  }

  syncMessagesAll() {
    return this.http.get(`daemons/messages/sync/`).then(response => response.data);
  }

  syncStatsAll() {
    return this.http.get(`daemons/sync/`).then(response => response.data);
  }

  syncMessages(id) {
    return this.http.get(`daemons/${id}/messages/`).then(response => response.data);
  }

  contactGiftsById(id) {
    return this.http.get(`daemons/${id}/contactGifts/`).then(response => response.data);
  }

  syncContactGiftsAll() {
    return this.http.get(`daemons/contactGifts/`).then(response => response.data);
  }

  syncDaemonsByTime(year, month) {
    return this.http.get(`daemons/sync/${month}/${year}/`).then(response => response.data);
  }
}
